import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FleetForm.module.scss';

interface FleetFormProps {
  values: {
    fleet: string;
    description: string;
  };
  handleChange: (field: keyof FleetFormProps['values'], value: string) => void;
  errors?: Record<string, string>;
}

const FleetForm: FC<FleetFormProps> = ({ values, handleChange, errors }) => {
  const { t } = useTranslation();

  return (
    <form>
      <div className={styles.grid}>
        <FloatLabelInput
          label={t('parameters.fleetsAndPositions.fleets.fleet')}
          value={values.fleet}
          onChange={(val) => handleChange('fleet', val)}
          error={errors?.fleet}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />

        <FloatLabelInput
          label={t('parameters.fleetsAndPositions.fleets.description')}
          value={values.description}
          onChange={(val) => handleChange('description', val)}
          error={errors?.description}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />
      </div>
    </form>
  );
};

export default FleetForm;
